// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__11pDC","itemTitle":"ClientEmergencyInfo_itemTitle__3cjOO","itemText":"ClientEmergencyInfo_itemText__l7yMe"};